export const GET_BRANCH_OPTIONS = 'GET_BRANCH_OPTIONS';
export const GET_BRANCH_OPTIONS_SUCCESS = 'GET_BRANCH_OPTIONS_SUCCESS';
export const GET_BRANCH_OPTIONS_FAILURE = 'GET_BRANCH_OPTIONS_FAILURE';

export const COPY_BRANCH_RULES = 'COPY_BRANCH_RULES';
export const COPY_BRANCH_RULES_SUCCESS = 'COPY_BRANCH_RULES_SUCCESS';
export const COPY_BRANCH_RULES_FAILURE = 'COPY_BRANCH_RULES_FAILURE';
